/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ScoreByDeviceAndDateLineChart_answersReport = {|
  +scoreByDeviceAndDate: ?$ReadOnlyArray<?{|
    +device: ?string;
    +scoreByDate: ?$ReadOnlyArray<?{|
      +date: ?string;
      +score: ?number;
      +count: ?number;
    |}>;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScoreByDeviceAndDateLineChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ScoreByDeviceAndDate",
      "name": "scoreByDeviceAndDate",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "device",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "ScoreByDate",
          "name": "scoreByDate",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "date",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "score",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceAndDateLineChart/__generated__/ScoreByDeviceAndDateLineChart_answersReport.graphql.js